var LoyaltyService = (function () {

    function checkLoyaltyProgramAvailabilityInBasket(cityId) {
        $.ajax({
            url: '/api/v6/zone?cityId=' + cityId + '&lon=0.0&lat=0.0',
            method: 'GET',
            contentType: 'application/json',
        }).done((result) => {
            if (!result.loyaltyProgram) {
                $('.js-delivery-loyalty-block').hide();
                $('.js-delivery-loyalty-block-mobile').hide();
                $('.js-pickup-loyalty-block').hide();
                $('.js-pickup-loyalty-block-mobile').hide();
            }
        });
    }

    function actionsOnFocus() {
        $('.js-courier-loyalty-points-mobile').focus(function () {
            let color = '#eb1f40';
            outerCircleCourier.style.stroke = color;
            innerCircleCourier.style.fill = color;
            document.getElementsByClassName('js-courier-loyalty-caption')[0].style.color = color;
        });

        $('.js-courier-loyalty-points-mobile').focusout(function () {
            if ($(this).val() === 0 || $(this).val() === "") {
                let color = '#c7c7cd';
                outerCircleCourier.style.stroke = color;
                innerCircleCourier.style.fill = color;
                document.getElementsByClassName('js-courier-loyalty-caption')[0].style.color = color;
            } else {
                $(this)[0].style.color = '#eb1f40';
            }
        });

        $('.js-pickup-loyalty-points-mobile').focus(function () {
            let color = '#eb1f40';
            outerCirclePickup.style.stroke = color;
            innerCirclePickup.style.fill = color;
            document.getElementsByClassName('js-pickup-loyalty-caption')[0].style.color = color;
        });

        $('.js-pickup-loyalty-points-mobile').focusout(function () {
            if ($(this).val() === 0 || $(this).val() === "") {
                let color = '#c7c7cd';
                outerCirclePickup.style.stroke = color;
                innerCirclePickup.style.fill = color;
                document.getElementsByClassName('js-pickup-loyalty-caption')[0].style.color = color;
            } else {
                $(this)[0].style.color = '#eb1f40';
            }
        });
    }

    function agreeToLoyaltyProgram() {
        $('.js-accept-loyalty-program').click(function () {
            data = {
                agree: true
            };
            AppService.toggleLoader();
            $.ajax({
                url: '/api/v7/user/optIn',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(data)
            }).done(() => {
                $(function () {
                    AppService.toggleLoader();
                    AppService.redirectTo("/user/profile#points");
                    location.reload();
                });
            });
        });
    }

    function goToLoyaltyIntro() {
        $('.js-navbar-loyalty-program-go-to-loyalty-intro').click(function () {
            AppService.redirectTo("/loyalty/intro")
        });
    }

    function goToLoyaltyInProfile() {
        $('.js-navbar-loyalty-program-redirect-to-profile').click(function () {
            if ($(location)[0].pathname === "/user/profile") {
                $("#tabs li:eq(2) a").tab('show');
            } else {
                AppService.redirectTo("/user/profile#points");
            }
        });
    }

    /* Google Analytics */
    function sendGoogleAnalyticsEventOnCondition(step, condition) {
        console.log(`loyaltyStep${step}`);
        if (condition) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(
                {
                    'event': `loyaltyStep${step}`
                }
            );
        }
    }

    function init() {

        agreeToLoyaltyProgram();
        goToLoyaltyIntro();
        goToLoyaltyInProfile();
        actionsOnFocus();

        $('.js-courier-loyalty-points-mobile').on('keyup', function () {
            let isValidInput = new RegExp('^[0-9]*$');
            let userInput = $(this).val();
            let finalPrice = $('.js-courier-final-price-mobile');
            $('.js-delivery-loyalty-block-mobile').css('height', '75px');
            if (!isValidInput.test(userInput)) {
                // Is not a number
                $(this).val(0)
            } else if (userInput === "" || userInput === 0) {
                $('.js-courier-points-caption-mobile').show();
                finalPrice.text(finalPrice.data('courier-price'));
            } else {
                $('.js-courier-points-caption-mobile').hide();
                $('.js-delivery-loyalty-block-mobile').css('height', '45px');
                let maximumPoints = $('.js-courier-loyalty-eggs-upper-bound').data('max-eggs-courier');
                if (userInput > maximumPoints) {
                    $(this).val(maximumPoints);
                    finalPrice.text(0);
                } else {
                    finalPrice.text(finalPrice.data('courier-price') - $(this).val());
                }
            }
        });

        $('.js-pickup-loyalty-points-mobile').on('keyup', function () {
            let isValidInput = new RegExp('^[0-9]*$');
            let userInput = $(this).val();
            let finalPrice = $('.js-pickup-final-price-mobile');
            $('.js-pickup-loyalty-block-mobile').css('height', '75px');
            if (!isValidInput.test(userInput)) {
                // Is not a number
                $(this).val(0)
            } else if (userInput === "" || userInput === 0) {
                $('.js-pickup-points-caption-mobile').show();
                finalPrice.text(finalPrice.data('pickup-price'));
            } else {
                $('.js-pickup-points-caption-mobile').hide();
                $('.js-pickup-loyalty-block-mobile').css('height', '45px');
                let maximumPoints = $('.js-pickup-loyalty-eggs-upper-bound').data('max-eggs-pickup');
                if (userInput > maximumPoints) {
                    $(this).val(maximumPoints);
                    finalPrice.text(0);
                } else {
                    finalPrice.text(finalPrice.data('pickup-price') - $(this).val())
                }
            }
        })
    }

    return {
        init: init,
        checkLoyaltyProgramAvailabilityInBasket: checkLoyaltyProgramAvailabilityInBasket,
        sendGoogleAnalyticsEventOnCondition: sendGoogleAnalyticsEventOnCondition
    };
})();

$(LoyaltyService.init);